var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-ancestor "},_vm._l((_vm.sOffres),function(offre,index){return _c('CarteOffre',{key:index,attrs:{"offre":offre,"size":_vm.getSize}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }